import React from 'react'

import ArticleIcon from '@mui/icons-material/Article'

import { PaperCardStyle } from '../styles'
import PaperModal from '../modals/PaperModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const PaperCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={ArticleIcon}
            cardStyle={PaperCardStyle}
            modal={<PaperModal {...props} />}
            title={props.title}
            description={props.description}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default PaperCard
